import React from 'react';
import classNames from 'classnames';
import { Typography, TYPOGRAPHY_WEIGHT } from '_atoms/Typography';

const isEmptyValue = (value: React.ReactNode): boolean =>
  value === undefined || value === null || value === '' || (Array.isArray(value) && value.length === 0);

interface DetailSectionProps {
  title: string;
  children: React.ReactNode;
  sectionRef?: React.Ref<HTMLElement>;
}

export const DetailSection: React.FC<DetailSectionProps> = ({ title, children, sectionRef }) => (
  <section ref={sectionRef} className="promotion-request-details__section">
    <div className="promotion-request-details__section-aside">
      <Typography.Title2 weight={TYPOGRAPHY_WEIGHT.BOLD}>{title}</Typography.Title2>
    </div>
    <div className="promotion-request-details__section-main">{children}</div>
  </section>
);

interface DetailFieldProps {
  label: string;
  children?: React.ReactNode;
  className?: string;
}

export const DetailField: React.FC<DetailFieldProps> = ({ label, children, className }) => (
  <div className={classNames('promotion-request-details__field', className)}>
    <Typography.Text className="promotion-request-details__field-label">{label}</Typography.Text>
    <div className="promotion-request-details__field-value">{isEmptyValue(children) ? '—' : children}</div>
  </div>
);
